import { PublicPageHeader } from "../../../components/headers/header-public-page/header-public-page";
import { Navbar } from "../../../components/nav";
import { ConcluidosCanceladosSetoresList } from "./components/concluidos-cancelados-setores-list/concluidos-cancelados-setores-list";
import { useStyles } from "./concluidos-cancelados-styles"

const ConcluidosCanceladosPage = () => {

   //AUX
   const classes = useStyles();

   return (
      <>
         <PublicPageHeader topOpacity="0.8" />
         <div className={classes.root}>
            <Navbar titulo="Concluídos e Cancelados" />
            <ConcluidosCanceladosSetoresList />
         </div>
      </>
   )
};

export default ConcluidosCanceladosPage